<template lang="pug">
  .block.block_wide
    .block__intro.block__item
      h2 Заявки на&nbsp;вступление
        |
        |
        sup.color-muted: b {{ requestsCount || '' }}
    .block__body.block__item.block__item_sm(v-if="!isReady")
      .loader.m-0
    .block__item.block__item_sm(v-show="isReady")
      .block__body.block__item.block__item_sm(v-show="!isEmpty")
        .block__body-item
          .input
            .input__icons
              .input__icon
                icon(icon-name="search")
            input.input__el(
              v-model="params.search"
              type="search"
              placeholder="Найти по имени..."
            )
            .input__border
            .input__icons
              button.input__icon.input__icon_hover(
                v-show="params.search"
                @click.prevent="params.search = null"
              )
                icon(icon-name='close-circle-s')
      .block__body.block__item.block__item_sm(v-show="!isEmpty" style="position: relative")
        .overlay.overlay_light.overlay_flex( v-show="isSearching && requestsSearchCount" style="z-index: 2")
          .overlay__content.overlay__content_top
            .loader
        section.empty-state(v-show="!requestsSearchCount")
          .loader.m-0(v-show="requestsLoading")
          .section__group.mt-0(v-show="!requestsLoading")
            .section__item Ничего не&nbsp;найдено
        template(
          v-for="(item, i) in requests"
        )
          .block__body-item(v-show="i !== 0")
            .divider
          .block__body-item
            Member(
              :userId="item.id"
              :name="item.fullName"
              :stacked="true"
              :img="item.avatarSmallUrl"
              :imgSize="64"
            )
              template(v-slot:name="")
                span.text-md {{ item.fullName }}
              template
                .text-xs {{ memberLocation(item.city, item.country) }}
                .text-sm.color-muted(v-show="item.createDate"): b Заявка отправлена <span class="text-lowercase" v-html="requestDate(item.createDate)"></span>
              template(v-slot:actions="")
                .member__buttons
                  button.button.button_primary(
                    :class="{ 'button_loading': getRequestStatus(item.id, 'accepting') }"
                    :disabled="getRequestStatus(item.id, 'accepting') || getRequestStatus(item.id, 'rejecting')"
                    @click="accept(item.id)"
                  )
                    span.button__text Принять <span class="d-none d-sm-inline-block">в&nbsp;клуб</span>
                    span.button__icon.button__loading
                      icon(icon-name='loading')
                  button.button.button_secondary(
                    :class="{ 'button_loading': getRequestStatus(item.id, 'rejecting') }"
                    :disabled="getRequestStatus(item.id, 'rejecting') || getRequestStatus(item.id, 'accepting') "
                    @click.prevent="reject(item.id)"
                  )
                    span.button__text Отклонить <span class="d-none d-sm-inline-block">заявку</span>
                    span.button__icon.button__loading
                      icon(icon-name='loading')
      InfiniteLoading(
        @infinite="infiniteLoader"
        :identifier="infiniteId"
      )
        div.loader(slot="spinner")
        div(slot="no-more")
        div(slot="no-results")
      .block__item.block__item_sm(v-show="isEmpty")
        section.empty-state
          .section__group.mt-0
            .section__item
              img(:src="$getTenantImg('noJoinRequests')" alt="")
            .section__item
              .text-lg: b Нет новых заявок на&nbsp;вступление в&nbsp;клуб
              .mt-8 Чтобы привлечь больше людей, поделитесь ссылкой на&nbsp;вступление в&nbsp;клуб
          .section__group
            .section__item
              .block-text.block-text_primary
                .steps-text
                  .steps-text__item
                    .input(
                      v-clipboard="() => refLink"
                      v-clipboard:success="refLinkCopied"
                    )
                      input.input__el(
                        :value="refLink"
                        readonly
                        style="pointer-events: none"
                      )
                      .input__icons
                        button.input__icon
                          icon(icon-name='copy')
                      .input__border
                  .steps-text__item
                    .heading-line.text-center
                      span.heading-line__text или поделитесь в&nbsp;соцсетях
                  .steps-text__item
                    YandexShare(:link="refLink")

</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { getCalendarDate } from '@/assets/js/helpers'
import Member from '@/components/Member'
import YandexShare from '@/components/YandexShare'
import { debounce } from 'lodash'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'ManageRequests',
  components: {
    Member,
    YandexShare,
    InfiniteLoading
  },
  data () {
    return {
      isSearching: false,
      params: {
        offset: 0,
        take: 12,
        search: null
      },
      infiniteId: +new Date(),
      refLink: window.location.origin + '/club/' + (this.$route.params.id || this.$getTenantIdClub())
    }
  },
  computed: {
    ...mapState('club', ['clubInfo']),
    ...mapState('clubManagement', ['requests', 'requestsCount', 'requestsSearchCount', 'requestsLoading', 'requestsStatus']),
    isEmpty () {
      return this.isReady && !this.requestsCount
    },
    isReady () {
      return this.clubInfo && this.requests
    },
    idClub () {
      return this.$route.params.id || this.$getTenantIdClub()
    }
  },
  methods: {
    ...mapActions('alerts', ['addSuccessAlert']),
    ...mapActions('clubManagement', ['getRequests', 'acceptRequest', 'rejectRequest']),
    ...mapMutations('clubManagement', ['clearRequests']),
    requestDate (date) {
      const d = getCalendarDate(date)
      let result = d.date
      if (d.isToday || d.isYesterday) {
        result += ` в&nbsp;${d.time}`
      }
      return result
    },
    memberLocation (city, country) {
      if (!city) {
        return null
      }
      let result = city
      if (country) {
        result += ', ' + country
      }
      return result
    },
    refLinkCopied () {
      this.addSuccessAlert('Ссылка скопирована')
    },
    search () {
      if (this.prevSearch === this.params.search) {
        return
      }
      this.prevSearch = this.params.search
      this.params.offset = 0
      this.isSearching = true
      this.loadItems()
    },
    infiniteLoader ($state) {
      this.infiniteState = $state
      this.params.offset = this.requests ? this.requests.length : 0
      this.loadItems()
    },
    loadItems () {
      this.getRequests({
        clubCode: this.idClub,
        searchString: this.params.search,
        offset: this.params.offset,
        take: this.params.take
      })
    },
    accept (userId) {
      this.acceptRequest({
        userId,
        clubCode: this.idClub
      })
    },
    reject (userId) {
      this.rejectRequest({
        userId,
        clubCode: this.idClub
      })
    },
    getRequestStatus (id, status) {
      return this.requestsStatus[id] && this.requestsStatus[id][status]
    }
  },
  watch: {
    'params.search' () {
      this.debouncedSearch()
    },
    requestsLoading (val) {
      if (val) {
        return
      }
      this.isSearching = false

      if (this.requests) {
        this.infiniteState && this.infiniteState.loaded()
        if (this.requests.length === this.requestsSearchCount) {
          this.infiniteState && this.infiniteState.complete()
        } else {
          this.infiniteId += 1
        }
      }
    }
  },
  created () {
    this.debouncedSearch = debounce(this.search, 500)
    this.clearRequests()
    this.loadItems()
  }
}
</script>

<style scoped>
  .member__buttons {
    min-width: 200px;
  }
</style>
